import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContentService} from "./services/content.service";
import {ContentFacade} from "./facades/content.facade";
import {GlobalSearchComponent} from './components/global-search/global-search.component';
import {ReactiveFormsModule} from "@angular/forms";


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        GlobalSearchComponent
    ],
    exports: [
        GlobalSearchComponent
    ],
    providers: [ContentService, ContentFacade]
})
export class ContentModule {
}
